const ShowDetailBasePath = '/show-detail';
export const ShowDetailApiPath = `${ShowDetailBasePath}/:showId`;
export const loadShowDetail = async (showId, axios) => {
  const requestUrl = `${ShowDetailBasePath}/${showId}`;
  const {
    data
  } = await axios.get(requestUrl);
  return data.data;
};